// extracted by mini-css-extract-plugin
module.exports = {"kanban":"KanbanView_kanban__1zObj","image":"KanbanView_image__3s7VK","feed":"KanbanView_feed__21qph","update-notice-container":"KanbanView_update-notice-container__3xprF"};